import { Component, computed, input } from '@angular/core'
import { InputCellContainerComponent } from '@app/feature/input-cells/input-cell-container/input-cell-container.component'
import { NO_GROUPED_RECORDS_KEY } from '@core/@ngrx'
import { Field } from '@core/models'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
    selector: 'app-grouping-values',
    templateUrl: './grouping-values.component.html',
    styleUrls: ['./grouping-values.component.sass'],
    imports: [TranslocoModule, InputCellContainerComponent],
})
export class GroupingValuesComponent {
    field = input.required<Field>()
    value = input.required<string>()

    isAssignee = computed(() => {
        return this.field().field_type_code === 'field_type_assignee'
    })

    isStatus = computed(() => {
        return this.field().field_type_code === 'field_type_status'
    })

    isNoGrouped = computed(() => {
        return this.value() === NO_GROUPED_RECORDS_KEY
    })
}
